/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Form, Button, ListGroup } from 'react-bootstrap';
import axios from 'axios';
import BASE_URL from '../config';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import debounce from 'lodash.debounce';
import './CreateQuotation.css';

const CreateService = ({ userData }) => {
  const initialInputs = {
    vehicle_no: '',
    desc: '',
    odoMeter: '',
    vehicleModel: '',
    paymentType: '',
    tasks: '',
    extraTasks: '',
    totalAmount: 0,
    customer: {
      title: '',
      name: '',
      email: '',
      nic: '',
      contactNo: ''
    },
    staffId: userData.staff_id
  };

  const [inputs, setInputs] = useState({ ...initialInputs });
  const [customers, setCustomers] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/customers`);
      setCustomers(response.data.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
      toast.error('Failed to fetch customers. Please try again.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (['title', 'name', 'email', 'nic', 'contactNo'].includes(name)) {
      setInputs((prevState) => ({
        ...prevState,
        customer: {
          ...prevState.customer,
          [name]: value
        }
      }));
  
      // Only search based on contact number
      if (name === 'contactNo') {
        const contactNo = value.trim().toLowerCase();
        if (contactNo.length > 0) {
          searchContactNo(contactNo); // Call the search for contact number
        } else {
          setSearchResults([]); // Clear search results if contact number is empty
        }
      }
    } else {
      setInputs((prevState) => ({
        ...prevState,
        [name]: value
      }));
    }
  };  

  const searchContactNo = useCallback(
    debounce((contactNo) => {
      if (contactNo.trim() !== '') {
        console.log('Searching for contact number:', contactNo);  // Log the contact number being searched for
        
        const results = customers.filter(
          (c) => `${c.contactNo}`.toLowerCase().includes(contactNo)
        );
        
        setSearchResults(results);
        
        if (results.length > 0) {
          console.log('Search results found:', results);  // Log search results if any match
        } else {
          console.log('No results found for contact number:', contactNo);  // Log when no results are found
        }
      }
    }, 300), 
    [customers]
  );  

  const handleSelectCustomer = (selectedCustomer) => {
    setInputs((prevState) => ({
      ...prevState,
      customer: {
        _id: selectedCustomer._id, // Store customer ID
        title: selectedCustomer.title,
        name: `${selectedCustomer.firstName} ${selectedCustomer.lastName}`,
        email: selectedCustomer.email,
        nic: selectedCustomer.nic,
        contactNo: selectedCustomer.contactNo
      }
    }));
    setSearchResults([]);
    toast.info('Customer selected.');
  };  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const { vehicle_no, odoMeter, vehicleModel, desc, paymentType, tasks, extraTasks, customer } = inputs;
  
    // Validate required fields
    if (!vehicle_no || !customer.contactNo) {
      toast.error('Please fill in all required fields.');
      return;
    }
  
    // Split the customer name
    const [firstName, lastName] = customer.name.split(' ');
  
    // Transform tasks and extraTasks into arrays of objects
    const taskArray = tasks.split('\n').map((line) => {
      const [task, unit, amount] = line.split(',').map((item) => item.trim());
      return { task, unit, amount: parseInt(amount, 10) };
    });
  
    const extraTaskArray = extraTasks.split('\n').map((line) => {
      const [extraTask, extraAmount] = line.split(',').map((item) => item.trim());
      return { extraTask, extraAmount: parseInt(extraAmount, 10) };
    });
  
    let serviceData = {
      vehicle_no,
      odoMeter,
      vehicleModel,
      desc,
      paymentType,
      tasks: taskArray,
      extraTasks: extraTaskArray,
      totalAmount: inputs.totalAmount,
      staffId: inputs.staffId
    };
  
    // Check if the customer is new or selected from existing customers
    if (inputs.customer._id) {
      // Use existing customer by ID
      serviceData.customerId = inputs.customer._id; // Only pass the customer ID if they already exist
    } else {
      // Include the new customer data
      serviceData.customer = {
        title: customer.title,
        firstName,
        lastName,
        email: customer.email,
        nic: customer.nic,
        contactNo: customer.contactNo
      };
    }
  
    try {
      // Send POST request to create the service
      const response = await axios.post(`${BASE_URL}/quotation`, serviceData);
      toast.success('Quotation created successfully.');
  
      // Reset the form inputs
      setInputs({ ...initialInputs });
  
      // Redirect to view all services
      navigate('/view-all-quotations');
    } catch (error) {
      console.error('Error creating service:', error);
      toast.error('Failed to create service. Please try again.');
    }
  };  

  return (
    <Container fluid className="create-service">
      <Row className="justify-content-md-center">
        <Col md={8}>
          <h1 className="text-center my-4">Create Quotation</h1>
          <Form onSubmit={handleSubmit}>
            <Row>
            <Col>
            <Form.Group controlId="formContactNumber">
  <Form.Label>Contact Number</Form.Label>
  <Form.Control
    type="text"
    name="contactNo"
    value={inputs.customer.contactNo}
    onChange={handleChange}
    required
    autoComplete="off"
    aria-expanded={searchResults.length > 0}
  />

  {searchResults.length > 0 && (
    <div className="search-results-container dropdown-menu show mt-2">
      <ListGroup>
        {searchResults.map((customer) => (
          <ListGroup.Item
            key={customer._id}
            action
            onClick={() => handleSelectCustomer(customer)}
            style={{ cursor: 'pointer' }}
          >
            {customer.contactNo}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  )}
</Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={inputs.customer.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              </Row>
              <br/>
              <Row>
            <Col>
            <Form.Group controlId="title">
  <Form.Label>Title</Form.Label>
  <Form.Select
    name="title"
    value={inputs.customer.title || ''}
    onChange={handleChange}
  >
    <option value="Mr.">Mr.</option>
      <option value="Ms.">Ms.</option>
      <option value="Mrs.">Mrs.</option>
      <option value="Dr.">Dr.</option>
      <option value="Prof.">Prof.</option>
      <option value=" ">None</option>
  </Form.Select>
</Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="name">
                  <Form.Label>Customer Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={inputs.customer.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              
            </Row>
            <br />
            <Row>
              <Col>
                <Form.Group controlId="nic">
                  <Form.Label>NIC</Form.Label>
                  <Form.Control
                    type="text"
                    name="nic"
                    value={inputs.customer.nic}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              
            </Row>
            <hr />
            <Form.Group controlId="vehicle_no">
              <Form.Label>Vehicle Number</Form.Label>
              <Form.Control
                type="text"
                name="vehicle_no"
                value={inputs.vehicle_no}
                onChange={handleChange}
              />
            </Form.Group>
            <br />
            <Form.Group controlId="vehicleModel">
              <Form.Label>Vehicle Model</Form.Label>
              <Form.Control
                type="text"
                name="vehicleModel"
                value={inputs.vehicleModel}
                onChange={handleChange}
              />
            </Form.Group>
            <br />
            <Form.Group controlId="odoMeter">
              <Form.Label>ODO Meter</Form.Label>
              <Form.Control
                type="text"
                name="odoMeter"
                value={inputs.odoMeter}
                onChange={handleChange}
              />
            </Form.Group>
            <br />
            <Form.Group controlId="desc">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="desc"
                value={inputs.desc}
                onChange={handleChange}
              />
            </Form.Group>
            <br />
            <Form.Group controlId="paymentType">
  <Form.Label>Payment Type</Form.Label>
  <Form.Control
    as="select"
    name="paymentType"
    value={inputs.paymentType}
    onChange={handleChange}
    required
  >
    <option value="">Select Payment type</option>
    <option value="CASH">CASH</option>
    <option value="CREDIT">CREDIT</option>
  </Form.Control>
</Form.Group>
<br />
            <Form.Group controlId="tasks">
              <Form.Label>Spare Part (Format: Spare Part, Quantity, Amount per line)</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="tasks"
                value={inputs.tasks}
                onChange={handleChange}
                placeholder="Vehicle Part 1, Quantity 1, Amount 1&#10;Vehicle Part 2, Quantity 2, Amount 2"
              />
            </Form.Group>
            <br />
            <Form.Group controlId="extraTasks">
              <Form.Label>Labor (Format: Labor, Amount per line)</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="extraTasks"
                value={inputs.extraTasks}
                onChange={handleChange}
                placeholder="Labor 1, Amount 1&#10;Labor 2, Amount 2"
              />
            </Form.Group>
            <Row>
              <Button style={{ backgroundColor: '#19325f' }} type="submit" className="mt-3">
                Create Quotation
              </Button>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default CreateService;